import { render } from "./index.vue?vue&type=template&id=bef881dc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bef881dc&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=bef881dc&lang=css"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bef881dc"]])

export default __exports__